import { render, staticRenderFns } from "./TechTray.vue?vue&type=template&id=c0083954&scoped=true"
import script from "./TechTray.vue?vue&type=script&setup=true&lang=js"
export * from "./TechTray.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TechTray.vue?vue&type=style&index=0&id=c0083954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0083954",
  null
  
)

export default component.exports